module.exports = __webpack_public_path__ + "img/more-scenes-icon-hover.013ee10d.png";